const PLACEHOLDER_IMAGE = 'https://cdn.cureskin.com/app/img/placeholder-product.png';

export function toPlainObject(obj: any): any {
  if (!obj) return {};
  return typeof obj.get === 'function' ? obj.toJSON?.() ?? JSON.parse(JSON.stringify(obj)) : obj;
}

export function findSmallestMargUnitVariant(variants: any[]): any {
  return [...variants].sort((a, b) => {
    const margUnitA = a.margUnit ?? a.get?.('margUnit') ?? 1;
    const margUnitB = b.margUnit ?? b.get?.('margUnit') ?? 1;
    return margUnitA - margUnitB;
  })[0];
}

export function buildVariantDataList(
  variants: any[],
  cartItemsList: any[],
  clickedProductId: string,
  section?: string,
): any[] {
  return variants
    .map((variant) => mapVariantToData(variant, cartItemsList))
    .sort((a, b) => sortVariants(a, b, clickedProductId, section));
}

function mapVariantToData(variant: any, cartItemsList: any[]): any {
  const cartItem = cartItemsList.find((item: any) => item.productId === variant.objectId);
  const v = toPlainObject(variant);
  const mrp = v.mrp ?? 0;
  const price = v.price ?? 0;
  const margUnit = v.margUnit ?? 1;
  return {
    objectId: v.objectId,
    cartQuantity: cartItem ? cartItem.quantity : 0,
    margUnit,
    quantity: v.quantity,
    perBottle: (price / (v.quantity)).toFixed(2),
    mrp,
    price,
    offPercentage: mrp > 0 ? Math.floor(((mrp - price) / mrp) * 100) : 0,
    quantityUnit: v.quantityUnit,
  };
}

function sortVariants(a: any, b: any, clickedProductId: string, section?: string): number {
  if (section === 'nutra_repeat_banner') {
    return b.margUnit - a.margUnit;
  }
  if (a.objectId === clickedProductId) return -1;
  if (b.objectId === clickedProductId) return 1;
  return 0;
}

export function resolveProductImage(
  productJson: any,
  smallestVariant: any,
  getURL: (url: string) => string,
): string {
  const rebrandedImg = smallestVariant?.rebrandedImageWithBackground
    ?? smallestVariant?.get?.('rebrandedImageWithBackground')
    ?? productJson.rebrandedImageWithBackground;
  const rebrandedUrl = Array.isArray(rebrandedImg) ? rebrandedImg[0] : rebrandedImg;
  const images = productJson.images ?? smallestVariant?.images ?? [];
  return rebrandedUrl
    || (images[0] ? getURL(images[0]) : null)
    || PLACEHOLDER_IMAGE;
}

export function resolveProductUnit(productJson: any, smallestVariant: any): string {
  const quantityUnit = productJson.quantityUnit ?? smallestVariant?.quantityUnit ?? '';
  return typeof quantityUnit === 'object' ? quantityUnit?.en ?? '' : quantityUnit ?? '';
}
